import {
  getMessageFromNetworkError,
  useTestAuthentication,
} from "@zapier/client";
import { useNotification } from "@zapier/utils";

interface Props {
  id?: number;
  title?: string;
}

export function useTestConnection({ id, title }: Props) {
  const { createNotification } = useNotification();
  const {
    isError,
    isLoading,
    isSuccess,
    mutate: testAuthentication,
  } = useTestAuthentication();

  const handleTestConnection = () => {
    if (!id) {
      return;
    }

    testAuthentication(
      { id },
      {
        onSuccess: () => {
          createNotification({
            message: `"${title}" is active`,
            type: "success",
          });
        },
        onError: (error: any) => {
          createNotification({
            title: `"${title}" is expired`,
            message: getMessageFromNetworkError(error),
            type: "error",
          });
        },
      },
    );
  };

  return {
    handleTestConnection,
    isTestConnectionError: isError,
    isTestConnectionLoading: isLoading,
    isTestConnectionSuccess: isSuccess,
  };
}
